import {Drawer, Grid} from "@mui/material"
import {useEffect, useState} from "react"
import ExpertBioNavigation from "../../molecules/ExpertBioNavigation/ExpertBioNavigation"
import ExpertBioHeader from "../../molecules/ExpertBioHeader/ExpertBioHeader"
import ExpertBioContent from "../../molecules/ExpertBioContent/ExpertBioContent"
import useExpertBioStore from "../../../stores/expertBioStore"
import {ExpertModel} from "../../../types/ExpertModel"
import {expertsEndpoints} from "../../../services/api/experts"
import {parseResponseToExpertModel} from "../../../helpers/parserHelper"
import {useConfigProvider} from "../../../config"
import "../../../dotcom-expert-bio-style.css"
import {ErrorMessage} from "../../molecules/ErrorMessage"
import {ErrorMessageAskExpert} from "../../atoms/errorMessages/ErrorMessageElements"
import {Account, AccountTeam} from "../../../types"
import {expertListStore} from "../../../stores"

const ExpertBio = () => {
  const [expertItem, setExpertItem] = useState<ExpertModel>()
  const [isExpertLoading, setIsExpertLoading] = useState<boolean>(true)
  const [hasError, setHasError] = useState<boolean>(false)
  const {getExpertBioPage} = expertsEndpoints()
  const {cmsImageUrl} = useConfigProvider()
  const {regions, searchTerm, clearSearchTerm, clearRegion} = expertListStore()

  const {
    expertId,
    displayExpert,
    originFrom,
    setExpertId,
    setDisplayExpert,
    setOriginFrom,
    setShowFindExpert,
  } = useExpertBioStore()

  const handleLoadExpert = async () => {
    setHasError(false)
    setIsExpertLoading(true)
    await getExpertBioPage(expertId)
      .then((data) => {
        setExpertItem(parseResponseToExpertModel(data, cmsImageUrl))
        setIsExpertLoading(false)
      })
      .catch(() => {
        setHasError(true)
      })
  }

  const handleCloseClick = async () => {
    setHasError(false)
    setIsExpertLoading(true)
    setShowFindExpert(false)
    if (regions !== "" || searchTerm !== "") {
      setTimeout(() => {
        clearRegion()
        clearSearchTerm()
      }, 1000)
    }
    await handleBackClick()
  }

  const handleBackClick = async () => {
    setHasError(false)
    setIsExpertLoading(true)
    setExpertId("")
    setDisplayExpert(false)
    setOriginFrom("")
  }

  useEffect(() => {
    if (expertId) {
      handleLoadExpert()
    }
  }, [expertId])

  return (
    <Drawer
      key={expertId}
      open={displayExpert}
      disableEnforceFocus
      anchor="right"
      sx={{
        zIndex: 100,
        marginTop: "88px",
        marginBottom: "72px",
        height: "100%",
        backdropFilter: "blur(5px)",
        "& .MuiBackdrop-root": {
          backgroundColor: "#1b1b1b",
          opacity: "0.25!important",
        },
        "& .MuiDrawer-paper": {
          width: "500px",
          backgroundColor: "white",
          backdropFilter: "blur(5px)",
          boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      <Grid container overflow="hidden" width="500px">
        <Grid
          size={12}
          sx={{
            borderBottom: "solid 1px #dedede",
            background: "#FFFFFF",
            padding: "8px 24px 8px 24px",
            width: "100%",
          }}
        >
          <ExpertBioNavigation
            toolTipText={`Back to  ${originFrom}`}
            onBackClick={handleBackClick}
            onCloseClick={handleCloseClick}
          />
        </Grid>
        {!hasError ? (
          <Grid>
            <Grid
              size={12}
              sx={{
                flexGrow: 0,
                padding: "16px 24px 16px 24px;",
                mixBlendMode: "darken",
                background: "#DEDEDE",
              }}
            >
              <ExpertBioHeader
                selectedMember={
                  {
                    accountTeamEmailAddress: expertItem?.email,
                    accountTeamFullName: expertItem?.name,
                    accountTeamId: "",
                    crmAccountId: "",
                    crmAccountName: "",
                    crmAccountNumber: "",
                  } as AccountTeam
                }
                contactData={
                  {
                    crmAccountId: "",
                    crmAccountURL: "",
                    crmAccountName: "",
                    parentAccountName: "",
                    parentAccountId: "",
                    country: "",
                    addressline1: "",
                    addressline2: "",
                    addressline3: "",
                    city: "",
                    stateorProvince: "",
                    postalCode: "",
                    telephoneNumber: "",
                    accountNumber: "",
                    relationshipManager: "",
                    relationshipManagerEmail: "",
                    lastUpdatedDateTime: "",
                    myControlRisksAccess: true,
                  } as Account
                }
                contactTeamData={[
                  {
                    accountTeamEmailAddress: expertItem?.email
                      ? expertItem?.email
                      : "",
                    accountTeamFullName: expertItem?.name
                      ? expertItem?.name
                      : "",
                    accountTeamId: "",
                    crmAccountId: "",
                    crmAccountName: "",
                    crmAccountNumber: "",
                  },
                ]}
                authorName={expertItem?.title || ""}
                imagePath={expertItem?.imageSmall || ""}
                location={expertItem?.location || ""}
                tags={expertItem?.servicesDisplayTags || []}
                loading={isExpertLoading}
              />
            </Grid>
            <Grid
              size={12}
              sx={{
                flexGrow: 0,
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                gap: "27px",
                padding: "16px 8px 24px 24px",
                background: "#FFFFFF",
              }}
            >
              <ExpertBioContent
                loading={isExpertLoading}
                contentText={expertItem?.textBlockValues || []}
              />
            </Grid>
          </Grid>
        ) : (
          <Grid
            size={12}
            sx={{
              flexGrow: 0,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              padding: "0px",
              background: "#FFFFFF",
              width: "100%",
            }}
          >
            <ErrorMessage
              messageElement={ErrorMessageAskExpert}
              message={""}
              messageStyle={{}}
              refetch={handleLoadExpert}
              containerStyle={{
                padding: "25px",
              }}
              buttonContainerStyle={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "20px",
              }}
            />
          </Grid>
        )}
      </Grid>
    </Drawer>
  )
}

export default ExpertBio
